import api from '@motionelements/core/src/api/base-api-v2';

// eslint-disable-next-line
export const getLibraryFolders = (params, axiosConfig) => {
  return api.get('/v2/folders', {
    params,
    ...(axiosConfig || {}),
  });
};

// eslint-disable-next-line
export const getFolder = (folderId, axiosConfig) => {
  return api.get(`/v2/folders/${folderId}`, {
    ...(axiosConfig || {}),
  });
};

// eslint-disable-next-line
export const createFolder = (params) => {
  return api.request('post', '/v2/folders', {
    params: api.getLocaleParams(),
    data: params,
  });
};

// eslint-disable-next-line
export const deleteFolder = async (folderId) => {
  return api.request('delete', `/v2/folders/${folderId}`, {
    params: api.getLocaleParams(),
  });
};

// eslint-disable-next-line
export const updateFolder = async (folderId, params) => {
  const url = `/v2/folders/${folderId}`;
  return api.request('patch', url, {
    params: api.getLocaleParams(),
    data: params,
  });
};

// eslint-disable-next-line
export const listFolderItems = (folderId, params, axiosConfig) => {
  return api.get(`/v2/folders/${folderId}/items`, {
    params: {
      ...api.getLocaleParams(),
      ...params,
    },
    ...(axiosConfig || {}),
  });
};

// eslint-disable-next-line
export const addFolderItems = (folderId, skus, axiosConfig) => {
  return api.request('post', `/v2/folders/${folderId}/items`, {
    // payload { sku || skus[] }
    data: { skus },
    ...(axiosConfig || {}),
  });
};

// eslint-disable-next-line
export const moveFolderItems = (fromFolderId, data, axiosConfig) => {
  return api.request('put', `/v2/folders/${fromFolderId}/items`, {
    data, // data { sku: String || skus: Array, target_id: String }
    ...(axiosConfig || {}),
  });
};

// eslint-disable-next-line
export const removeFolderItems = (folderId, data, axiosConfig) => { // payload {  }
  return api.request('delete', `/v2/folders/${folderId}/items`, {
    data, // data { sku: String || skus: Array }
    ...(axiosConfig || {}),
  });
};

// eslint-disable-next-line
export const publishFolder = (folderId, privacy, axiosConfig) => {
  return api.request('post', `/v2/folders/${folderId}/publish`, {
    data: {
      privacy,
    },
    ...(axiosConfig || {}),
  });
};

// eslint-disable-next-line
export const unpublishFolder = (folderId, axiosConfig) => {
  return api.request('post', `/v2/folders/${folderId}/unpublish`, {
    ...(axiosConfig || {}),
  });
};

// eslint-disable-next-line
export const shareFolder = async (folderId, params) => {
  return api.request('post', `/v2/folders/${folderId}/share`, {
    params: api.getLocaleParams(),
    data: params,
  });
};

// eslint-disable-next-line
export const pinFolderItem = (folderId, sku) => {
  return api.request('post', `/v2/folders/${folderId}/items/${sku}/pin`);
};

// eslint-disable-next-line
export const unpinFolderItem = (folderId, sku) => {
  return api.request('post', `/v2/folders/${folderId}/items/${sku}/unpin`);
};
